import ImageWithBackup from '@components/ImageWithBackup'
import { Star } from '@components/icons'
import imageLoader from '@utilities/imageLoader'

const Images = ({
  title,
  inCarousel,
  picUrl,
  isMemberOnly,
}: {
  picUrl: string[]
  title: string
  inCarousel: boolean
  isMemberOnly: boolean
}) => {
  return (
    <div className="relative w-full" style={{ backgroundColor: 'lightgray' }}>
      {picUrl.length > 2 ? (
        <div
          className={`flex gap-1 border-b-4 border-gray-300 ${
            inCarousel ? 'h-48' : 'h-48 md:h-40 xl:h-48'
          }`}
        >
          <div className="w-2/3 h-full">
            <div className="relative h-full">
              <ImageWithBackup
                loader={imageLoader}
                unoptimized
                fill
                className="object-cover object-center"
                alt={title}
                src={picUrl[0]}
              />
            </div>
          </div>
          <div className="w-1/3 grid grid-rows-2 gap-1 h-full">
            <div className="relative">
              <ImageWithBackup
                loader={imageLoader}
                unoptimized
                fill
                className="object-cover object-center"
                alt={title}
                src={picUrl[1]}
              />
            </div>
            <div className="relative">
              <ImageWithBackup
                loader={imageLoader}
                unoptimized
                fill
                className="object-cover object-center"
                alt={title}
                src={picUrl[2]}
              />
            </div>
          </div>
        </div>
      ) : (
        <div className="relative w-full h-48 md:h-40 xl:h-48 border-b-4 border-gray-300">
          <ImageWithBackup
            loader={imageLoader}
            unoptimized
            fill
            className="object-cover object-center"
            alt={title}
            src={picUrl[0]}
          />
        </div>
      )}
      {isMemberOnly && (
        <div className="flex items-center pt-1 bg-bidfta-blue-dark w-full text-align-center justify-center border-2 border-bidfta-yellow">
          <div className="text-bidfta-yellow mr-1 mb-1">
            <Star height={'16'} width={'16'} />
          </div>
          <span className="text-white">Members Only Auction</span>
        </div>
      )}
    </div>
  )
}

export default Images
